var loadVideos;

$(function () {
    loadVideos = {
        page: 1,
        loading: false,
        finished: false,
        textSearch: textSearch,

        formataURL: function (url) {
            url = url.replace("http://", "").replace("https://", "");
            let pos = url.indexOf("/");
            url = url.substr(0, pos);
            return url;
        },

        formataData: function (dataBD) {
            dataBD = new Date(dataBD);
            let vDia = dataBD.getDate();
            if (vDia.toString().length == 1) vDia = "0" + vDia;
            let vMes = dataBD.getMonth() + 1;
            if (vMes.toString().length == 1) vMes = "0" + vMes;
            let vAno = dataBD.getFullYear();
            return vDia + "/" + vMes + "/" + vAno;
        },

        embedVideo: function (url) {
            var embedCode = url.split("?v=");
            return embedCode[1];
        },

        formataImgBg: function (img) {
            if (img) {
                img = img.replace(/(<([^>]+)>)/gi, "");
                return 'style="background-image:url(' + img + ')"';
            } else {
                return '';
            }
        },

        fnImage: function (img) {
            return img ? `/api/v1/diminuator?file=img/videos/${img}&w=350&h=180` : 'icon-conectassma-white.png';
        },

        showType: function (type) {
            if (type === 'list') {
                $(".lista-videos").removeClass("grid").addClass("list");
                $(".view-type.list").removeClass("disabled").addClass("enabled");
                $(".view-type.grid").removeClass("enabled").addClass("disabled");
            } else {
                $(".lista-videos").removeClass("list").addClass("grid");
                $(".view-type.grid").removeClass("disabled").addClass("enabled");
                $(".view-type.list").removeClass("enabled").addClass("disabled");
            }
        },

        analytics: function(){
            let loadingElements = document.getElementsByClassName('loading');
            if (typeof gtag === "function" && loadingElements.length > 0) {
                gtag('event', 'page_view', {
                    'event_category': 'videos',
                    'event_label': 'Page ' + loadVideos.page,
                    'value': 1
                });
            }
          },

        load: function () {
            if (loadVideos.finished) return;
            $(".loading").fadeIn();
            loadVideos.loading = true;
            loadVideos.page = loadVideos.page + 1;
            $.ajax({
                dataType: "json",
                url: loadVideos.textSearch == "" ? `/api/v1/videos/${loadVideos.page}/` : `/api/v1/videos/${loadVideos.textSearch}/${loadVideos.page}/`,
                success: function (req) {
                  if (req[1].videos.length == 0) {
                      loadVideos.finished = true;
                    } else {
                      //advertising
                      let ad = req[0].advertising[0];
                      let ad_template = `<div class="cell large-12 ultra-banner">
                                        <div class="desktop"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_desktop}" /></a></div>
                                        <div class="mobile"><a href="/redirect/advertising/?url=${ad.url}&id=${ad.id}" rel="nofollow" target="_blank"><img src="${ad.imagem_mobile}" /></a></div>
                                        </div>`;
                      $(".lista-videos.main").append(ad_template);
                      $.get(`/api/advertising-views/${ad.id}/`)
                      //Videos
                      $(req[1].videos).each(function (ix, not) {
                          let template = `
                          <div class="video cell large-4">
                              <div class="content grid-x grid-padding-x">
                                  <div class="cell large-3">
                                      <div class="imagem alinhamento-vertical">
                                        <div class="play"><a href="/redirect/videos/?url=${not.url}" rel="nofollow" target="_blank"><img src="/static/img/botao-play.png" /></a></div>
                                        <a href="/redirect/videos/?url=${not.url}" rel="nofollow" target="_blank"><img src="${loadVideos.fnImage(not.imagem_local)}"/></a>
                                      </div>
                                  </div>
                                  <div class="info-video col-info cell large-9">
                                      <div class="organizacao"><a href="/redirect/videos/?url=${not.url_site}" rel="nofollow" target="_blank">${not.organizacao}</a></div>
                                      <div class="data" >${loadVideos.formataData(not.data)}</div>
                                      <h2><a href="/redirect/videos/?url=${not.url}" rel="nofollow" target="_blank">${not.titulo}</a></h2>
                                      <div class="descricao">${not.descricao.replace(/(<([^>]+)>)/gi, "").substr(0,300)}[...]</div>
                                  </div>
                              </div>
                          </div>
                        `;
                        $(".lista-videos.main").append(template);
                      });
                  }
                  $(".loading").fadeOut();
                  loadVideos.analytics();
                  loadVideos.loading = false;
                }
            });
        },

        search: function(div){
          var search = $(`.search-form.${div} #searchText`).val().toString();
          if(!search){
              document.location.href = `/youtube/`;
          } else {
              document.location.href = `/youtube/${search}/`;
          }
        }
    };

    $(".search-form.desktop .icon").click(function(){
      $(".search-form .form").animate({width:'toggle'},350);
      $("#searchText").focus();
    });

    $(".search-form.desktop #btnOk").click(function(){ loadVideos.search('desktop'); });
    $(".search-form.mobile #btnOk").click(function(){ loadVideos.search('mobile'); });

    $(".search-form.desktop #searchText").on('keypress',function(e) {
      if(e.which == 13) $(".search-form.desktop #btnOk").click()
    });

    $(".view-type.grid").click(function () {
        loadVideos.showType("grid");
    });
    $(".view-type.list").click(function () {
        loadVideos.showType("list");
    });

    if(textSearch){
      $(".search-form.desktop #searchText,.search-form.mobile #searchText").val(textSearch)
      $(".search-form").addClass("search")
    }

    window.onscroll = function(ev) {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = Math.max(
      document.body.scrollHeight, document.documentElement.scrollHeight,
      document.body.offsetHeight, document.documentElement.offsetHeight,
      document.body.clientHeight, document.documentElement.clientHeight
    );

    if (scrollTop + windowHeight >= documentHeight - 100) {
      if (loadVideos.loading === false) {
        loadVideos.load();
      }
      $('#back-to-top').addClass('visible');
    } else {
      if (scrollTop != 0) {
        $('#back-to-top').addClass('visible');
      } else {
        $('#back-to-top').removeClass('visible');
      }
    }

  };
});

$("#back-to-top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, "slow", function () {
        $('#back-to-top').removeClass('visible');
    });
});
